// src/services/api.js
import axios from "axios";
import authService from "./auth";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = authService.getAuthHeader();
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      authService.logout();
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export const employeeAPI = {
  // Widget endpoint
  inviteViaWidget: (data) => api.post("/employees/invite", data),

  // Dashboard endpoints
  createCandidate: (data) => api.post("/employees", data),
  listEmployees: (params = {}) => api.get("/employees", { params }),
  getEmployee: (employeeId) => api.get(`/employees/${employeeId}`),
  updateEmployee: (employeeId, data) =>
    api.patch(`/employees/${employeeId}`, data),
  getStatistics: () => api.get("/employees/statistics"),

  // Bulk operations
  bulkCreate: (data) => api.post("/employees/bulk", data),
  getBulkStatus: (bulkJobId) => api.get(`/employees/bulk/${bulkJobId}`),

  // Export
  exportEmployee: (employeeId) => api.post(`/employees/${employeeId}/export`),
};

export const flowAPI = {
  requestOTP: (data) => api.post("/flow/otp/request", data),
  verifyOTP: (data) => api.post("/flow/otp/verify", data),
  createIdSession: (data) => api.post("/flow/id/session", data),
  checkRTW: (data) => api.post("/flow/rtw/check", data),
  complete: (data) => api.post("/flow/complete", data),
};

export const billingAPI = {
  getUsage: () => api.get("/usage/current"),
  getPlans: () => api.get("/billing/plans"),
  getCurrentPlan: () => api.get("/billing/current-plan"),
  createCheckout: (data) => api.post("/billing/checkout-session", data),
};

export const tagAPI = {
  // Tag CRUD
  createTag: (data) => api.post("/tags", data),
  listTags: () => api.get("/tags"),
  getTag: (tagId) => api.get(`/tags/${tagId}`),
  updateTag: (tagId, data) => api.patch(`/tags/${tagId}`, data),
  deleteTag: (tagId) => api.delete(`/tags/${tagId}`),
};

export default api;
